import _ from 'lodash';
import moment from 'moment';
// import { LocalStorage } from "../Storage";
function getSuffix(j, k) {
	let suffix = "th";

	if (j === 1 && k !== 11) {
		suffix = "st";
	}

	if (j === 2 && k !== 12) {
		suffix = "nd";
	}

	if (j === 3 && k !== 13) {
		suffix = "rd";
	}

	return suffix;
}
export default {
	currencyFormat(input, currency = '$', show_sign = false) {
		if(!_.isNumber(input)){
			return input || '';
		}

		const
			million =  10 ** 6,
			thousand = 10 ** 3,
			number = parseInt(input),
			sign = Math.sign(number),
			sign_symbol = show_sign && sign === -1 ? '-' : '';

		let
			letter = '',
			abs = Math.abs(number);

		const
			// is_number_thousand = (abs < million) && (abs >= thousand),
			is_number_thousand = abs < million,
			is_number_million = abs >= million;

		if (is_number_thousand) {
			abs = Math.round10(abs / thousand);
			letter = 'k';
		}
		else if (is_number_million) {
			abs = Math.round10((abs / million), -3);
			letter = 'm';
		}

		return sign_symbol + currency + abs + letter;
	},
	getPlayerAvatarUrl({ id, size, format = 'png' }){
		if(!id){
			throw new Error('Player ID should be defined');
		}

		const
			path = process.env.PLAYERS_PATH;
			// version = `?v=${LocalStorage.get('web_version') || Date.now()}`;

		size = size ? `_${size}` : '';
		format = `.${format}`;

		return path + id + size + format;
	},
	ordinalSuffixOf(num){
		if (!parseInt(num, 10)) {
			return num;
		}
		const
			j = num % 10,
			k = num % 100;

		let suffix = getSuffix(j, k);

		return num + suffix;
	},

	mixinDateFormat(date, format) {
		return moment(date).format(format);
	},

	isIOSDevice() {
		return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
	},

	mixinNumberOrDash(value) {
		return _.isNumber(value) ? value : '-'
	}
}